

import { createApp } from 'vue'
import App from './App.vue'
// import router from './router'   // <- 移除静态导入

import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'

import vConsole from 'vconsole'


import i18n from "@/i18n";
import { initRem } from '@/common/ts/adaptation';



initRem({
    designWidth: 1920,
    baseFont: 14,
    minFont: 11,
    maxFont: 18,
    pcThreshold: 750
});

const pinia = createPinia()
pinia.use(piniaPluginPersist)

const app = createApp(App)

if (window.location.href.includes('debug=1')) {
    new vConsole()
}

// 先注册 i18n 和 pinia，确保后续动态导入的路由/组件能安全使用 useI18n
app.use(pinia)
app.use(i18n)

    // 动态导入 router，避免在模块解析阶段同步加载页面组件导致 useI18n 在插件注册前被调用
    ; (async () => {
        const { default: router } = await import('./router')
        app.use(router)
        app.mount('#app')
    })()
